import { render, staticRenderFns } from "./DeliveryBlockTransportDetails.vue?vue&type=template&id=456b1dea&"
import script from "./DeliveryBlockTransportDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockTransportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports